enum Mutations {
  SET_IS_FUNNEL_SAVE_STOP_OPEN = 'setIsFunnelSaveStopOpen',
}

export default Mutations
